import { motion, useReducedMotion } from 'motion/react'

interface Mote {
  id: number
  left: number
  size: number
  delay: number
  duration: number
  drift: number
  dim: boolean
}

const MOTES: Mote[] = Array.from({ length: 16 }, (_, i) => ({
  id: i,
  left: (i * 41 + 7) % 100,
  size: 2 + ((i * 11) % 4),
  delay: (i * 1.1) % 9,
  duration: 11 + ((i * 5) % 9),
  drift: ((i % 5) - 2) * 22,
  dim: i % 3 !== 0,
}))

export function AmbientBackdrop({ accent = 'var(--ember)' }: { accent?: string }) {
  const reduced = useReducedMotion()

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(110% 60% at 50% -10%, ${accent === 'var(--ember)' ? 'rgba(255,180,84,0.07)' : `${accent}12`}, transparent 60%), radial-gradient(80% 50% at 50% 115%, var(--surface-sunken), transparent 70%)`,
        }}
      />
      {[0, 1].map((i) => (
        <motion.div
          key={`haze-${i}`}
          className="absolute left-1/2 rounded-[50%]"
          style={{
            width: `${150 - i * 30}%`,
            height: '42%',
            bottom: `${-30 + i * 8}%`,
            x: '-50%',
            background: `radial-gradient(60% 100% at 50% 0%, ${i === 0 ? 'rgba(255,180,84,0.05)' : 'rgba(255,180,84,0.035)'}, transparent 70%)`,
            filter: 'blur(2px)',
          }}
          animate={reduced ? undefined : { y: [0, i === 0 ? -6 : 6, 0] }}
          transition={{ duration: 12 + i * 3, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
      {!reduced &&
        MOTES.map((m) => (
          <motion.span
            key={m.id}
            className="absolute rounded-full"
            style={{
              left: `${m.left}%`,
              bottom: '-4%',
              width: m.size,
              height: m.size,
              background: 'var(--ember)',
              boxShadow: '0 0 6px rgba(255,180,84,0.8)',
              opacity: 0,
            }}
            animate={{ y: [0, -420], x: [0, m.drift], opacity: [0, m.dim ? 0.35 : 0.7, 0] }}
            transition={{ duration: m.duration, delay: m.delay, repeat: Infinity, ease: 'linear' }}
          />
        ))}
    </div>
  )
}
